<template>
  <div class="m-timeline-area" :style="`width: ${width}px`">
    <div class="m-timeline">
      <div
        :class="['m-timeline-item', {'last': index === timelineDesc.length - 1}]"
        v-for="(item, index) in timelineDesc"
        :key="index">
        <div class="u-tail"></div>
        <div class="u-dot"></div>
        <div class="u-title" v-if="index==timelineDesc.length-1">{{ item.czrName || '--' }}发出{{type}}</div>
        <div class="u-title" v-else >{{ item.czrName || '--' }}已回复</div>
        <div class="u-content" v-if="index==timelineDesc.length-1">申请人：{{ item.czrName || '--' }}</div>
         <div class="u-content" v-else>处理人：{{ item.czrName || '--' }}</div>
        <div class="u-content">{{ item.content || '--' }}</div>
        <div class="u-createTime">{{ item.createTime || '--' }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'timeline',
  props: {
    timelineDesc: { // 时间轴内容数组
      type: Array,
      default: () => {
        return []
      }
    },
    width: { // 时间轴区域总宽度
      type: Number,
      default: 360
    },
     type: { // 时间轴区域总宽度
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
@blue: #1890ff;
@green: #52c41a;
@red: #f5222d;
@gray: rgba(0,0,0,.25);
.m-timeline-area {
  margin: 0 auto;
  .m-timeline {
    .m-timeline-item {
      position: relative;
      padding-bottom: 20px;
      .u-tail {
        position: absolute;
        top: 10px;
        left: 5px;
        height: calc(100% - 10px);
        border-left: 2px solid #e8e8e8; // 实线
        // border-left: 2px dotted #e8e8e8; // 点线
        // border-left: 2px dashed #e8e8e8; // 虚线
      }
      .u-dot {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid @blue;
        border-radius: 50%;
      }
      .u-content {
        position: relative;
        top: -6px;
        margin-left: 30px;
        word-break: break-all;
        word-wrap: break-word;
        line-height: 24px;
        font-size: 14px;
      }
      .u-createTime{
        color: #696969;
        font-size: 13px;
        margin-left: 30px;
      }

      .u-title{
        font-size: 16px;
        color: #000;
        position: relative;
        top: -6px;
        margin-left: 30px;
        margin-bottom: 10px;
      }
    }
    .last {
      .u-tail {
        display: none;
      }
    }
  }
}
</style>